const environmentsUtilsHanlder = () => {
  const { TBX_UNITY_API } = window.__TBX_ENV__;
  let result = 'production';
  if (TBX_UNITY_API.includes('-cert')) result = 'certification';
  if (TBX_UNITY_API.includes('-dev')) result = 'development';
  return result;
};

export const ENVIROMENTS = environmentsUtilsHanlder();
